export const RQ_GET_MISSED_CALL_REPORTS_API = {
  url: 'reports/web/effort/missedcallreport/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>',
  method: 'GET',
  auth: true,

};
